import { ConversationListItem } from '../../../../../../../../store/dashboard/askAica/types';
import { WA_ROW_ID_PREFIX } from '../../../../../../../../store/globalAskAica/whatsapp/constants';
import { WhatsAppChatSummary } from '../../../../../../../../store/globalAskAica/whatsapp/types';
import { SidebarRow } from './types';

const toRow = (chat: WhatsAppChatSummary): SidebarRow => ({
    conversation_id: `${WA_ROW_ID_PREFIX}${chat.chatId}`,
    user_id: '',
    user_name: null,
    title: chat.title,
    last_message_at: chat.lastMessageAt,
    whatsAppChat: chat,
});

const recency = (row: SidebarRow): number => (row.last_message_at ? Date.parse(row.last_message_at) || 0 : 0);

/**
 * Web conversations and WhatsApp chats in one list, newest first. With no WhatsApp chats the
 * web list is returned untouched, so its order is exactly what Athena sent.
 * Web rows win ties because they precede WhatsApp rows in the concatenation and
 * `Array.prototype.sort` is stable (ES2019); do not swap the order below.
 */
export const mergeByRecency = (conversations: ConversationListItem[], chats: WhatsAppChatSummary[]): SidebarRow[] =>
    chats.length === 0 ? conversations : [...conversations, ...chats.map(toRow)].sort((a, b) => recency(b) - recency(a));
